import { Button, Flex, Stack, Text } from '@mantine/core'
import { modals } from '@mantine/modals'

import { Icons } from 'src/common/components'

import useDeleteTag from '../../hooks/useDeleteTag.hook'

const DeleteTagContent = ({
  tagId,
  onMutationSuccess,
}: {
  tagId: string
  onMutationSuccess: () => void
}) => {
  const { deleteTag, deleteMutationStatus } = useDeleteTag()

  const handleDelete = async () => {
    await deleteTag(tagId)
    onMutationSuccess()
  }

  return (
    <>
      <Stack align="center" justify="center" gap="md">
        <Icons.Warning width="60" height="60" color="red" />
        <Text size={'16px'} fw={700} style={{ color: 'red' }}>
          Confirm Tag Removal
        </Text>
        <Text size={'14px'} fw={400} style={{ whiteSpace: 'pre-wrap' }}>
          Are you sure you want to delete this tag?
        </Text>
      </Stack>
      <Flex justify="space-between" align="flex-start" mt="lg">
        <Button onClick={() => modals.closeAll()} variant="outline">
          Cancel
        </Button>
        <Button
          color="red"
          loading={deleteMutationStatus === 'pending'}
          type="submit"
          variant="filled"
          onClick={handleDelete}
        >
          Delete Tag
        </Button>
      </Flex>
    </>
  )
}
export default DeleteTagContent
